import moment from 'moment'

export default function (value, na = undefined) {
  // 01/30/2019 => 2019-01-30 (US => military)
  return value && value.trim() !== '' ? moment(value).format('YYYY-MM-DD') : na
};
